export const Theme = {
  amber: {
    header: 'rgba(247, 189, 74, 1)', // '#f7bd4a'
    graph: 'rgba(247, 189, 74, 0.2)',
  },
  deepBlue: {
    header: 'rgba(125, 206, 130, 1)', // '#7DCE82'
    graph: 'rgba(125, 206, 130, 0.2)',
  },
  pink: {
    header: 'rgba(240, 98, 146, 1)', // '#f06292'
    graph: 'rgba(240, 98, 146, 0.2)',
  },
  emerald: {
    header: 'rgba(59, 176, 255, 1)', // '#3bb0ff'
    graph: 'rgba(59, 176, 255, 0.2)',
  },
  azure: {
    header: 'rgba(59, 176, 255, 1)', // '#3bb0ff'
    graph: 'rgba(59, 176, 255, 0.2)',
  },
  grey: {
    header: 'rgba(158, 158, 158, 1)', // '#3bb0ff'
    graph: 'rgba(59, 176, 255, 0.2)',
  },
  dashboard: {
    header: 'rgba(229, 229, 229, 1)',
    graph: 'rgba(30, 69, 140, 0.2)',
    font: 'rgba(51, 51, 51, 1)',
  },
};

export const Theme2 = {
  amber: {
    header: '#ffb74d', // #ee7c0c
    graph: 'rgba(238, 124, 12, 0.2)',
  },
  deepBlue: {
    header: '#7986cb', //'#1e458c'
    graph: 'rgba(30, 69, 140, 0.2)',
  },
  pink: {
    header: '#f06292', // '#f07fbb'
    graph: 'rgba(240, 127, 187, 0.2)',
  },
  emerald: {
    header: '#81c784', //' #17c47a'
    graph: 'rgba(23, 196, 122, 0.2)',
  },
  azure: {
    header: '#42a5f5', //' #3bb0ff'
    graph: 'rgba(59, 176, 255, 0.2)',
  },
  grey: {
    header: 'rgb(158, 158, 158, 1)', //' #3bb0ff'
    graph: 'rgba(59, 176, 255, 0.2)',
  },
};
